/**
 * @description
 * @author Kody
 * @date 2018-10-09
 */

import Api from '../../../path';
import { fetchData } from '@umu/umu-fetch';
import { reportError } from 'common/src/services/errorLogger';

import IInput from './models/input';
import IOutput from './models/output';

export const getThemeList = (data: IInput): Promise<IListResponse<IOutput>> => {
    return fetchData(Api.SHARE_THEME_LIST, data)
        .then((res: IListResponse<IOutput>) => {
            return res.data;
        })
        .catch((err: any) => {
            reportError({
                error: err,
                componentName: 'getThemeList',
                props: data,
                additionalInfo: {
                    description: 'getThemeList fetchData error',
                },
            });
            throw err;
        });
};
